import { render, staticRenderFns } from "./ReglasUso.vue?vue&type=template&id=16866c82&scoped=true&"
import script from "./ReglasUso.vue?vue&type=script&lang=js&"
export * from "./ReglasUso.vue?vue&type=script&lang=js&"
import style0 from "./ReglasUso.vue?vue&type=style&index=0&id=16866c82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16866c82",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol})
